import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddMeterNodeDialogComponent } from './add-meter-node-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { CardDialogModule } from '../card-dialog/card-dialog.module';
import { MatSelectModule } from '@angular/material/select';
import { MaterialModule } from 'src/app/core/material/material.module';
import { BaseModule } from 'src/app/core/base/base.module';



@NgModule({
  declarations: [
    AddMeterNodeDialogComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatButtonModule,
    CardDialogModule,
    MatSelectModule,
    MaterialModule,
    BaseModule
  ],
  exports: [
    AddMeterNodeDialogComponent
  ]
})
export class AddMeterNodeDialogModule { }
